export default __webpack_public_path__ + "static/media/51.a0ca85a3.jpeg";